// RIVL Mock Data — swap with Supabase queries when backend is wired

export const mockUser = {
  id: 'u_001',
  name: 'Alex Mercer',
  handle: '@alexm',
  email: 'alex@rivl.app',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200',
  totalRuns: 42,
  totalDistanceKm: 318.4,
  bestPace: '4:12',
  verifiedFinishes: 7,
};

// Generate event dates relative to today so the demo always feels current
const _now = new Date();
const _addDays = (d) => new Date(_now.getTime() + d * 86400000).toISOString();

export const mockEvents = [
  {
    id: 'evt_001',
    name: 'Harbour Half Marathon',
    organizer: 'Coastal Run Club',
    type: 'official',
    date: _addDays(18),
    distanceKm: 21.1,
    location: 'Lagos, NG',
    participants: 1248,
    capacity: 1500,
    status: 'open',
    image: 'https://images.unsplash.com/photo-1771402900228-683f1957dd12?w=1200',
    bibMode: 'validated',
    medalEnabled: true,
    description: 'A scenic half marathon along Tafawa Balewa Square with verified finish certificates.',
    fee: 65,
    currency: 'NGN',
  },
  {
    id: 'evt_002',
    name: 'City Lights 10K',
    organizer: 'Urban Striders',
    type: 'community',
    date: _addDays(7),
    distanceKm: 10,
    location: 'Melbourne, AU',
    participants: 287,
    capacity: 500,
    status: 'open',
    image: 'https://images.pexels.com/photos/4083911/pexels-photo-4083911.jpeg?w=1200',
    bibMode: 'none',
    medalEnabled: false,
    description: 'Evening 10K through the city centre. Lightweight community event.',
    fee: 0,
    currency: 'NGN',
  },
  {
    id: 'evt_003',
    name: 'Mountain Trail 25K',
    organizer: 'Peak Runners',
    type: 'official',
    date: _addDays(34),
    distanceKm: 25,
    location: 'Blue Mountains, AU',
    participants: 412,
    capacity: 600,
    status: 'open',
    image: 'https://images.pexels.com/photos/35273265/pexels-photo-35273265.jpeg?w=1200',
    bibMode: 'self-assigned',
    medalEnabled: true,
    description: 'Challenging trail race with full GPS verification.',
    fee: 90,
    currency: 'NGN',
  },
  {
    id: 'evt_004',
    name: 'Sunrise 5K',
    organizer: 'Dawn Runners',
    type: 'community',
    date: _addDays(3),
    distanceKm: 5,
    location: 'Brisbane, AU',
    participants: 156,
    capacity: 300,
    status: 'open',
    image: 'https://images.unsplash.com/photo-1774050021155-f2c0fa1a9658?w=1200',
    bibMode: 'none',
    medalEnabled: false,
    description: 'Easy social 5K to start your day.',
    fee: 0,
    currency: 'NGN',
  },
];

export const mockParticipation = {
  id: 'part_001',
  eventId: 'evt_001',
  userId: 'u_001',
  bibNumber: '2417',
  state: 'joined', // joined | bib-linked | check-in-open | checked-in | ready | live | finished | verified | unverified
  checkedInAt: null,
  finishedAt: null,
  finishTimeSec: null,
  qrToken: 'RIVL-2417-A8B2C9',
};

export const mockLeaderboard = [
  { rank: 1, name: 'Sara Chen', bib: '0142', time: '1:14:22', verified: true, pace: '3:31' },
  { rank: 2, name: 'Marcus Bell', bib: '0218', time: '1:15:08', verified: true, pace: '3:33' },
  { rank: 3, name: 'Priya Anand', bib: '0089', time: '1:16:45', verified: true, pace: '3:38' },
  { rank: 4, name: 'James OConnor', bib: '0511', time: '1:17:12', verified: true, pace: '3:39' },
  { rank: 5, name: 'Yuki Tanaka', bib: '0067', time: '1:18:01', verified: true, pace: '3:41' },
  { rank: 6, name: 'Alex Mercer', bib: '2417', time: '1:32:44', verified: true, pace: '4:23', isYou: true },
  { rank: 7, name: 'Tom Reilly', bib: '1102', time: '1:33:18', verified: false, pace: '4:25' },
  { rank: 8, name: 'Lina Park', bib: '0904', time: '1:34:02', verified: true, pace: '4:27' },
];

export const mockFeed = [
  { id: 'f1', type: 'finish', user: 'Sara Chen', avatar: '', text: 'finished Harbour Half Marathon in 1:14:22', time: '2h ago', verified: true },
  { id: 'f2', type: 'join', user: 'Marcus Bell', avatar: '', text: 'joined Mountain Trail 25K', time: '4h ago' },
  { id: 'f3', type: 'event', user: 'Coastal Run Club', avatar: '', text: 'opened registration for Harbour Half Marathon', time: '1d ago' },
  { id: 'f4', type: 'pr', user: 'Priya Anand', avatar: '', text: 'set a new personal best of 1:16:45', time: '2d ago', verified: true },
];

export const mockFriends = [
  { id: 'u_002', name: 'Sara Chen', handle: '@sarac', status: 'friend', races: 12 },
  { id: 'u_003', name: 'Marcus Bell', handle: '@mbell', status: 'friend', races: 8 },
  { id: 'u_004', name: 'Priya Anand', handle: '@priya', status: 'pending', races: 19 },
  { id: 'u_005', name: 'James OConnor', handle: '@jamesoc', status: 'friend', races: 5 },
];

export const mockPersonalRuns = [
  { id: 'r1', date: '2026-02-20', distanceKm: 8.2, durationSec: 2580, paceMinPerKm: '5:14', visibility: 'private' },
  { id: 'r2', date: '2026-02-18', distanceKm: 12.5, durationSec: 3960, paceMinPerKm: '5:17', visibility: 'friends' },
  { id: 'r3', date: '2026-02-15', distanceKm: 5.0, durationSec: 1500, paceMinPerKm: '5:00', visibility: 'public' },
  { id: 'r4', date: '2026-02-12', distanceKm: 15.8, durationSec: 5040, paceMinPerKm: '5:19', visibility: 'private' },
];

export const mockOrgEvents = mockEvents.map(e => ({
  ...e,
  registered: e.participants,
  checkedIn: Math.floor(e.participants * 0.6),
  ready: Math.floor(e.participants * 0.55),
  finished: Math.floor(e.participants * 0.4),
  verified: Math.floor(e.participants * 0.38),
  underReview: 6,
  rejected: 2,
  raceState: 'pre-start',
}));

export const mockOrgParticipants = Array.from({ length: 24 }, (_, i) => ({
  id: `p${i + 1}`,
  bib: String(1000 + i).padStart(4, '0'),
  name: ['Sara Chen','Marcus Bell','Priya Anand','James OConnor','Yuki Tanaka','Alex Mercer','Tom Reilly','Lina Park'][i % 8],
  state: ['joined','checked-in','ready','live','finished','verified','under-review'][i % 7],
  finishTime: i % 7 === 5 ? `1:${20 + i}:${(i*3)%60}`.padStart(7,'0') : null,
}));

export const mockReviewCases = [
  { id: 'rev_1', bib: '1102', name: 'Tom Reilly', coverage: 87, finishTime: '1:33:18', anomalies: ['Early shortcut at km 8'], routeQuality: 'partial' },
  { id: 'rev_2', bib: '2204', name: 'Eve Holloway', coverage: 96, finishTime: '1:48:02', anomalies: ['GPS dropout 0.4km'], routeQuality: 'good' },
  { id: 'rev_3', bib: '0815', name: 'Daniel Park', coverage: 71, finishTime: '1:22:40', anomalies: ['Implausible pace section'], routeQuality: 'partial' },
];

// Admin
export const mockAdminMetrics = {
  totalUsers: 14820,
  activeMonth: 4291,
  totalEvents: 312,
  liveEvents: 4,
  verifiedFinishes: 28944,
  revenueMonth: 18430,
};

export const mockAdminUsers = Array.from({ length: 12 }, (_, i) => ({
  id: `u_${100 + i}`,
  name: ['Sara Chen','Marcus Bell','Priya Anand','James OConnor','Yuki Tanaka','Alex Mercer','Tom Reilly','Lina Park','Eve Holloway','Daniel Park','Ines Vega','Nik Roth'][i],
  email: `user${i}@example.com`,
  role: i === 0 ? 'admin' : (i % 4 === 0 ? 'organizer' : 'runner'),
  status: i % 7 === 0 ? 'suspended' : 'active',
  joined: '2025-11-' + String(10 + i).padStart(2, '0'),
}));

export const mockTiers = [
  { id: 'free', name: 'Free', price: 0, features: ['Personal runs', 'Community events', 'Basic verification'], events: 'Unlimited', mau: '500' },
  { id: 'pro', name: 'Pro', price: 49, features: ['Official events', 'Manual review', 'CSV bib upload', 'Priority support'], events: 'Unlimited', mau: '5,000' },
  { id: 'enterprise', name: 'Enterprise', price: 199, features: ['Custom branding', 'API access', 'Dedicated support', 'SLA'], events: 'Unlimited', mau: 'Unlimited' },
];

// route polyline for map mocks (lat/lng) — Lagos Island loop around Tafawa Balewa Square
export const mockRoutePath = [
  { lat: 6.4502, lng: 3.3936 },
  { lat: 6.4515, lng: 3.3945 },
  { lat: 6.4530, lng: 3.3955 },
  { lat: 6.4545, lng: 3.3960 },
  { lat: 6.4555, lng: 3.3950 },
  { lat: 6.4560, lng: 3.3935 },
  { lat: 6.4555, lng: 3.3920 },
  { lat: 6.4540, lng: 3.3910 },
  { lat: 6.4525, lng: 3.3905 },
  { lat: 6.4510, lng: 3.3915 },
  { lat: 6.4502, lng: 3.3925 },
  { lat: 6.4502, lng: 3.3936 },
];
